export const noteHeadingClasses = 'font-semibold text-slate-900';
